import React from 'react'
function OttPlatFormsList(props) {
  const { ottPlatformFun, localValue } = props
  console.log(props.ottListValues, 'ottListValues')
  function ciEquals(a, b) {
    return typeof a === 'string' && typeof b === 'string'
      ? a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0
      : a === b
  }

  return (
    <div
      style={{
        display: 'flex',
        margin: '9px',
        gap: '10px',
        flexDirection: 'column',
      }}
    >
      <div style={{ display: 'flex', marginTop: '4px', gap: '10px', flexWrap: 'wrap' }}>
        {props.ottListValues &&
          props.ottListValues.map(value => (
            <div key={value} className='chipBox'>
              <div
                onClick={ottPlatformFun}
                value={value}
                className={
                  localValue &&
                  localValue.some(item => {
                    if (ciEquals(item, value)) {
                      return true
                    }

                    return undefined
                  })
                    ? 'colorBlue'
                    : 'chipBoxRed'
                }
              >
                {value}
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}

export default OttPlatFormsList
